// extracted by mini-css-extract-plugin
module.exports = {"banner":"banner___iU22o","gals-logo":"gals-logo___2GOnK","galsLogo":"gals-logo___2GOnK","text":"text___SFgkt"};